import React from 'react'

const TokenFallbackIcon = ({ className = '', size = 40, ...rest }) => (
  <svg
    viewBox="0 0 40 40"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label="Token placeholder icon"
    {...rest}
  >
    <defs>
      <linearGradient id="token-fallback-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#7CFC98" />
        <stop offset="100%" stopColor="#a135bb" />
      </linearGradient>
    </defs>
    <rect
      x="0"
      y="0"
      width="40"
      height="40"
      rx="12"
      fill="rgba(34, 37, 47, 0.85)"
      stroke="url(#token-fallback-gradient)"
      strokeWidth="2"
    />
    <path
      d="M20 10c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 4c2.209 0 4 1.79 4 4 0 1.657-1.343 3-3 3h-2v-2h2a1 1 0 0 0 0-2h-1c-1.657 0-3-1.343-3-3 0-2.21 1.791-4 4-4zm0 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      fill="url(#token-fallback-gradient)"
    />
  </svg>
)

export default TokenFallbackIcon

